/* ViCera subscription-first buy box.
   Drives the theme's native selling-plan radios from the styled UI so that
   theme.js keeps handling pricing and cart submission unchanged. */
(function () {
  function init() {
    var box = document.querySelector('.vc-buybox');
    if (!box) return;

    var freq = box.querySelector('[data-vc-freq]');
    var subToggle = box.querySelector('[data-vc-sub-toggle]');
    var card = box.querySelector('[data-vc-plan-card]');
    var wrap = box.querySelector('[data-vc-plan-wrap]');
    var oneCard = box.querySelector('[data-vc-onetime-card]');
    var oneTime = box.querySelector('[data-vc-onetime-toggle]');

    function fire(el) {
      el.checked = true;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function paint() {
      var subActive = !!(subToggle && subToggle.checked);
      if (card) card.classList.toggle('vc-plan--muted', !subActive);
      if (wrap) wrap.classList.toggle('vc-plan--muted', !subActive);
      if (oneCard) oneCard.classList.toggle('is-active', !subActive);
    }

    if (freq && subToggle) {
      freq.addEventListener('change', function () {
        subToggle.value = freq.value;
        fire(subToggle);
      });
    }

    [subToggle, oneTime].forEach(function (el) {
      if (el) el.addEventListener('change', function () { setTimeout(refresh, 60); });
    });

    // Subscription is the default selection: price it that way on load.
    // Re-applied on a short delay because the theme's own product scripts
    // initialise after DOMContentLoaded and would otherwise repaint the
    // one-time price over ours.
    // The theme's own product script repaints the headline price after load.
    // Keep the headline in sync with whichever option is selected.
    var subPrice = box.getAttribute('data-vc-sub-price');
    var oneTimePrice = box.getAttribute('data-vc-onetime-price');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-compare-price]');

    function syncHeadline() {
      if (!priceEl) return;
      var subActive = subToggle && subToggle.checked;
      priceEl.textContent = subActive ? subPrice : oneTimePrice;
      if (compareEl) {
        compareEl.textContent = subActive ? oneTimePrice : '';
        compareEl.style.display = subActive ? '' : 'none';
      }
      var note = document.querySelector('.product__price--subnote');
      if (note) note.style.display = subActive ? 'block' : 'none';
    }

    // CTA label: state the commitment. Subscription selected -> "SUBSCRIBE NOW",
    // one-time -> "ADD TO CART". Pre-order products override both with "PRE-ORDER".
    var isPreorder = box.getAttribute('data-vc-preorder') === 'true';
    var ctaTextEl = document.querySelector('[data-add-to-cart-text]');
    var ctaBtn = document.querySelector('[data-add-to-cart]');
    var ctaBaseLabel = ctaTextEl ? ctaTextEl.textContent.trim() : '';
    var ctaGuard = false;

    function ctaLabel() {
      var soldOut = /sold out|unavailable/i.test(ctaBaseLabel);
      if (soldOut) return ctaBaseLabel;
      if (isPreorder) return 'PRE-ORDER';
      var subActive = subToggle && subToggle.checked;
      return subActive ? 'START SUBSCRIPTION' : 'ADD TO CART';
    }

    function syncCta() {
      if (!ctaTextEl) return;
      var want = ctaLabel();
      if (ctaTextEl.textContent.trim() === want) return;
      ctaGuard = true;
      ctaTextEl.textContent = want;
      if (ctaBtn) ctaBtn.setAttribute('aria-label', want);
      setTimeout(function () { ctaGuard = false; }, 0);
    }

    if (ctaTextEl && window.MutationObserver) {
      new MutationObserver(function () {
        if (ctaGuard) return;
        syncCta();
      }).observe(ctaTextEl, { childList: true, characterData: true, subtree: true });
    }

    // The Add to Cart button prints the variant's list price from Liquid and the
    // theme never repaints it on a selling-plan change. Keep it in sync.
    var btnPriceEl = document.querySelector('[data-button-price]');
    var btnPriceGuard = false;

    function syncButtonPrice() {
      if (!btnPriceEl) return;
      var subActive = subToggle && subToggle.checked;
      var want = subActive ? subPrice : oneTimePrice;
      if (!want) return;
      if (btnPriceEl.textContent.trim() === want.trim()) return;
      btnPriceGuard = true;
      btnPriceEl.textContent = want;
      setTimeout(function () { btnPriceGuard = false; }, 0);
    }

    if (btnPriceEl && window.MutationObserver) {
      new MutationObserver(function () {
        if (btnPriceGuard) return;
        syncButtonPrice();
      }).observe(btnPriceEl, { childList: true, characterData: true, subtree: true });
    }

    function refresh() { paint(); syncHeadline(); syncButtonPrice(); syncCta(); }

    refresh();
    window.addEventListener('load', refresh);
    setTimeout(refresh, 500);
    setTimeout(refresh, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
